<template>
  <div class="xianxia-xingwei-detail child-detail">
    <ChildModal :needDate="needDate" :title="$store.state.childModalTitle">
      <div class="tab">
        <div :class="['left', {'current': curTab == 0}]">
          <div class="left"></div>
          <div @click="curTab=0" class="right light-box">
            <div class="icon">
              <img src="../../assets/youkexianxiaxingweifenxi/icon4.png" />
            </div>
            <div class="text">停留隔夜等行为</div>
          </div>
        </div>
        <div :class="['right', {'current': curTab == 1}]">
          <div @click="curTab=1" class="left light-box">
            <div class="icon">
              <img src="../../assets/youkexianxiaxingweifenxi/icon3.png" />
            </div>
            <div class="text">游客消费行为</div>
          </div>
          <div class="right"></div>
        </div>
      </div>
      <div class="detail1" v-show="curTab == 0">
        <div class="geyebili single-line">
          <div class="chart-title">隔夜比例</div>
          <div class="chart-content">
            <ol>
              <li :class="{ current: geyebili_fenlei == 0 }" @click="geyebili_fenlei = 0">全体</li>
              <li :class="{ current: geyebili_fenlei == 1 }" @click="geyebili_fenlei = 1">分类1</li>
              <li :class="{ current: geyebili_fenlei == 2 }" @click="geyebili_fenlei = 2">分类2</li>
              <li :class="{ current: geyebili_fenlei == 3 }" @click="geyebili_fenlei = 3">分类3</li>
              <li :class="{ current: geyebili_fenlei == 4 }" @click="geyebili_fenlei = 4">分类4</li>
              <li :class="{ current: geyebili_fenlei == 5 }" @click="geyebili_fenlei = 5">分类5</li>
            </ol>
            <ul>
              <li class="yibiao1">
                <div class="bg"></div>
                <div class="pointer" ref="pointer1"></div>
                <div class="info">
                  <div class="bili">
                    {{
                    geyebiliData
                    ? Math.round(
                    (geyebiliData[0].value / geyebiliData[0].total) * 100
                    )
                    : 0
                    }}%
                  </div>
                  <div class="name">省外游客隔夜</div>
                </div>
              </li>
              <li class="yibiao2">
                <div class="bg"></div>
                <div class="pointer" ref="pointer2"></div>
                <div class="info">
                  <div class="bili">
                    {{
                    geyebiliData
                    ? Math.round(
                    (geyebiliData[1].value / geyebiliData[1].total) * 100
                    )
                    : 0
                    }}%
                  </div>
                  <div class="name">全部游客隔夜</div>
                </div>
              </li>
              <li class="yibiao3">
                <div class="bg"></div>
                <div class="pointer" ref="pointer3"></div>
                <div class="info">
                  <div class="bili">
                    {{
                    geyebiliData
                    ? Math.round(
                    (geyebiliData[2].value / geyebiliData[2].total) * 100
                    )
                    : 0
                    }}%
                  </div>
                  <div class="name">省内游客隔夜</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="tingliushijian single-line">
          <div class="chart-title">游客停留时间</div>
          <div class="chart-content">
            <ol>
              <li :class="{ current: tingliushijian_fenlei == 0 }" @click="tingliushijian_fenlei = 0">综合停留</li>
              <li :class="{ current: tingliushijian_fenlei == 1 }" @click="tingliushijian_fenlei = 1">年龄对比</li>
              <li :class="{ current: tingliushijian_fenlei == 2 }" @click="tingliushijian_fenlei = 2">周边对比</li>
            </ol>
            <StackBar2 :chartData="tingliushijianData" id="tingliushijian" unit="%" />
          </div>
        </div>
        <div class="zhusuretu single-line" v-if="zhusuretuData">
          <div @click="goPage('/home/zhusuretu')" class="chart-title">住宿热图</div>
          <div class="chart-content">
            <ol>
              <li :class="{ current: zhusuretuData.curMonth == item }" :key="index" @click="zhusuretuData.curMonth = item" v-for="(item, index) in 12">{{ item }}月</li>
            </ol>
            <div style="height:226px;point-event:none;">
              <AmapHeatmap :center="zhusuretuData.curCenter" :chartData="zhusuretuData.data" id="zhusuretu" />
            </div>
          </div>
          <div @click="cityListShow = !cityListShow" class="expand">
            <div class="local"></div>
            <div class="city-name">{{ zhusuretuData.curArea }}</div>
            <div class="arrow"></div>
            <ul class="city-list" v-show="cityListShow">
              <li :key="index" @click="chooseCity(item)" v-for="(item, index) in zhusuretuData.allArea">{{ item }}</li>
            </ul>
          </div>
        </div>
        <div class="jiaotongfangshi single-line">
          <div class="chart-title">游客交通方式分析</div>
          <div class="chart-content">
            <JiaotongFangshi :chartData="JiaotongFangshiData" id="jiaotongfangshi" />
          </div>
        </div>
        <div class="xiaofeiqianli single-line">
          <div class="chart-title">游客消费潜力分析</div>
          <div class="chart-content">
            <SingleBar :chartData="XiaofeiQianliData" id="xiaofeiqianli" unit="%" />
          </div>
        </div>
        <div class="laiyuanjuli single-line">
          <div class="chart-title">游客来源距离</div>
          <div class="chart-content">
            <PolarBar :chartData="LaiyuanJuliData" :legendRight="210" id="laiyuanjuli" />
          </div>
        </div>
      </div>
      <div class="detail2" v-if="curTab == 1">
        <div class="xiaofeizonglan single-line">
          <div class="chart-title">2019年7月游客总体消费总览</div>
          <div class="chart-content">
            <ul class="info-list">
              <li>
                <div class="icon">
                  <img src="../../assets/youkexianxiaxingweifenxi/spend1.png" />
                </div>
                <div class="text">
                  <div class="up">金额/万元</div>
                  <div :style="{color: colorList[0]}" class="down">12433.19</div>
                </div>
              </li>
              <li>
                <div class="icon">
                  <img src="../../assets/youkexianxiaxingweifenxi/spend2.png" />
                </div>
                <div class="text">
                  <div class="up">刷卡笔数</div>
                  <div :style="{color: colorList[1]}" class="down">129211</div>
                </div>
              </li>
              <li>
                <div class="icon">
                  <img src="../../assets/youkexianxiaxingweifenxi/spend3.png" />
                </div>
                <div class="text">
                  <div class="up">刷卡人数/人</div>
                  <div :style="{color: colorList[2]}" class="down">93829</div>
                </div>
              </li>
              <li>
                <div class="icon">
                  <img src="../../assets/youkexianxiaxingweifenxi/spend4.png" />
                </div>
                <div class="text">
                  <div class="up">人均消费/元</div>
                  <div :style="{color: colorList[3]}" class="down">2324</div>
                </div>
              </li>
            </ul>
            <div class="spend-map">
              <BtMap :areaCode="MapData.areaCode" :drillDown="0" :itemList="MapData.itemList" :legendConf="MapData.legendConf" :mapData="MapData.mapData" :mask="0" v-if="MapData" />
            </div>
          </div>
        </div>
        <div class="line">
          <div class="xiaofeiedugechengshizhanbi">
            <div class="chart-title">游客消费额度各城市占比</div>
            <div class="chart-content">
              <Ring :chartData="XiaofeiEduGeChengshiZhanbiData" id="xiaofeiedugechengshizhanbi" v-if="XiaofeiEduGeChengshiZhanbiData" />
            </div>
          </div>
          <div class>
            <div class="chart-title">各城市人均消费对比</div>
            <div class="chart-content">
              <SingleBarLong :barWidth="16" :chartData="GeChengshiRenjunXiaofeiDuibiData" id="gechengshirenjunxiaofeiduibi" interval="0" v-if="GeChengshiRenjunXiaofeiDuibiData" />
            </div>
          </div>
        </div>
        <div class="line">
          <div class>
            <div class="chart-title">7月游客各行业消费组成</div>
            <div class="chart-content">
              <Pie3d :chartData="GeHangyeXiaofeiZuchengData" v-if="GeHangyeXiaofeiZuchengData.length > 0" />
            </div>
          </div>
          <div class="genianlinrenjunxiaofei">
            <div class="chart-title">7月游客各年龄人均消费</div>
            <div class="chart-content">
              <Radar :center="{x:'30%', y:'50%'}" :chartData="GeNianlinRenjunXiaofeiData" id="genianlinrenjunxiaofei" />
            </div>
          </div>
        </div>
        <div class="line">
          <div class>
            <div class="chart-title">不同年龄消费额度占比</div>
            <div class="chart-content">
              <PolarBar :barWidth="12" :chartData="ButongNianlinXiaofeiEduZhanbiData" :legendRight="12" id="butongnianlinxiaofeieduzhanbi" />
            </div>
          </div>
          <div class="xingbiexiaofeiduibi">
            <div class="chart-title">不同性别消费对比</div>
            <div class="chart-content">
              <ol>
                <li :class="{ current: true }">总消费额度</li>
                <li>人均</li>
              </ol>
              <XingbieBili :chartData="ButongXingbieXiaofeiDuibiData" id="xingbiexiaofeiduibi" v-if="ButongXingbieXiaofeiDuibiData" />
            </div>
          </div>
        </div>
        <div class="single-line butongnianlingehangyexiaofeizuchengduibi">
          <div class="chart-title">游客不同年龄层各行业消费组成对比</div>
          <div class="chart-content">
            <ol>
              <li>总消费额度</li>
              <li :class="{ current: true }">人均</li>
            </ol>
            <StackBar2 :chartData="ButongNianlinGeHangyeXiaofeiZuchengData" :colorList="colorList2" id="ButongNianlinGeHangyeXiaofeiZucheng" unit="%" />
          </div>
        </div>
        <div class="single-line xiaofeizongedubianhuaqushi">
          <div class="chart-title">消费总额度变化趋势</div>
          <div class="chart-content">
            <ol>
              <li :class="{ current: true }">消费总额度</li>
              <li>刷卡人次</li>
              <li>人均花费</li>
            </ol>
            <AreaLine :chartData="XiaofeiZongEduBianhuaQushiData" :colorList="colorList3" id="XiaofeiZongEduBianhuaQushi" />
          </div>
        </div>
        <div class="single-line gaoxiaofeiyoukelaiyuandizhanbi">
          <div class="chart-title">高消费游客来源地占比</div>
          <div class="chart-content">
            <div class="tip">注：指消费5000元以上的游客</div>
            <ol>
              <li :class="{ current: true }">全部</li>
              <li>省内</li>
              <li>省外</li>
            </ol>
            <SingleBarLong :barWidth="18" :chartData="GaoxiaofeiYoukeLaiyuandiZhanbiData" :colorPairs="colorPairs" :dataZoom="false" id="gaoxiaofeiyoukelaiyuandizhanbi" interval="0" v-if="GaoxiaofeiYoukeLaiyuandiZhanbiData" />
          </div>
        </div>
        <div class="single-line xiaofeiretu">
          <div class="chart-title">消费热力图</div>
          <div class="chart-content">
            <div style="height:226px;">
              <AmapHeatmap :center="XiaofeiRetuData.curCenter" :chartData="XiaofeiRetuData.data" id="xiaofeiretu" />
            </div>
          </div>
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from '@/components/Common/ChildModal.vue'
import StackBar2 from '@/components/Echarts/StackBar2.vue'
import AmapHeatmap from '@/components/Echarts/AmapHeatmap.vue'
import JiaotongFangshi from '@/components/Echarts/JiaotongFangshi.vue'
import SingleBar from '@/components/Echarts/SingleBar.vue'
import PolarBar from '@/components/Echarts/PolarBar.vue'
import BtMap from '@/components/BorderMapComponent/index.vue'
import Pie3d from '@/components/Highcharts/Pie3d.vue'
import Radar from '@/components/Echarts/Radar.vue'
import SingleBarLong from '@/components/Echarts/SingleBarLong.vue'
import Ring from '@/components/Echarts/Ring.vue'
import XingbieBili from '@/components/Echarts/XingbieBili.vue'
import AreaLine from '@/components/Echarts/AreaLine.vue'

export default {
  name: 'XianxiaXingweiFenxiDetail',
  components: {
    ChildModal,
    StackBar2,
    AmapHeatmap,
    JiaotongFangshi,
    SingleBar,
    PolarBar,
    BtMap,
    Pie3d,
    Radar,
    SingleBarLong,
    Ring,
    XingbieBili,
    AreaLine
  },
  props: {},
  data() {
    return {
      geyebiliData: '',
      geyebili_fenlei: 0,
      tingliushijian_fenlei: 1,
      tingliushijianData: null,
      zhusuretuData: null,
      cityListShow: false,
      JiaotongFangshiData: null,
      XiaofeiQianliData: null,
      LaiyuanJuliData: [],
      curTab: 0,
      colorList: ['#00cdff', '#4be8ca', '#ffdc48', '#ff7352'],
      MapData: null,
      XiaofeiEduGeChengshiZhanbiData: '',
      colorList2: ['#065493', '#0b81af', '#4cabce', '#36b29a', '#d35454'],
      colorList3: ['#00cdff', '#ff7352'],
      colorPairs: ['#1c8a75', '#44d7bb']
    }
  },
  computed: {
    needDate() {
      if (this.curTab) {
        return true
      }
      return false
    }
  },
  mounted() {
    // 请求隔夜比例
    fetch('/data/Home/XianxiaXingweiFenxiDetail/GeyeBili.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.geyebiliData = json.data
        setTimeout(() => {
          var deg1 = Math.round((json.data[0].value / json.data[0].total) * 180)
          var deg2 = Math.round((json.data[1].value / json.data[1].total) * 180)
          var deg3 = Math.round((json.data[2].value / json.data[2].total) * 180)
          this.$refs.pointer1.style.transform = 'rotate(' + deg1 + 'deg)'
          this.$refs.pointer2.style.transform = 'rotate(' + deg2 + 'deg)'
          this.$refs.pointer3.style.transform = 'rotate(' + deg3 + 'deg)'
        }, 500)
      })
    // 请求停留时间
    fetch('/data/Home/XianxiaXingweiFenxiDetail/TingliuShijian.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        setTimeout(() => {
          this.tingliushijianData = json.data
        }, 500)
      })
    // 请求住宿热图
    fetch('/data/Home/XianxiaXingweiFenxiDetail/ZhusuRetu.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.zhusuretuData = json.data
      })
    // 请求交通方式
    fetch('/data/Home/XianxiaXingweiFenxiDetail/JiaotongFangshi.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.JiaotongFangshiData = json.data
      })
    // 请求消费潜力
    fetch('/data/Home/XianxiaXingweiFenxiDetail/XiaofeiQianli.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.XiaofeiQianliData = json.data
      })
    // 请求来源距离
    fetch('/data/Home/XianxiaXingweiFenxiDetail/LaiyuanJuli.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.LaiyuanJuliData = json.data
      })

    // 请求地图数据
    fetch('/data/Home/XianxiaXingweiFenxiDetail/MapData.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.MapData = json.data
      })
    // 请求各城市人均消费对比
    fetch(
      '/data/Home/XianxiaXingweiFenxiDetail/XiaofeiEduGeChengshiZhanbi.json'
    )
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.XiaofeiEduGeChengshiZhanbiData = json.data
      })

    // 请求各城市人均消费对比
    fetch(
      '/data/Home/XianxiaXingweiFenxiDetail/GeChengshiRenjunXiaofeiDuibi.json'
    )
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.GeChengshiRenjunXiaofeiDuibiData = json.data
      })
    // 请求各行业消费组成
    fetch('/data/Home/XianxiaXingweiFenxiDetail/GeHangyeXiaofeiZucheng.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.GeHangyeXiaofeiZuchengData = json.data
      })
    // 请求各年龄人均消费
    fetch('/data/Home/XianxiaXingweiFenxiDetail/GeNianlinRenjunXiaofei.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.GeNianlinRenjunXiaofeiData = json.data
      })
    // 请求不同年龄消费额度占比
    fetch(
      '/data/Home/XianxiaXingweiFenxiDetail/ButongNianlinXiaofeiEduZhanbi.json'
    )
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.ButongNianlinXiaofeiEduZhanbiData = json.data
      })
    // 请求不同性别消费对比
    fetch('/data/Home/XianxiaXingweiFenxiDetail/ButongXingbieXiaofeiDuibi.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.ButongXingbieXiaofeiDuibiData = json.data
      })
    // 请求不同年龄层各行业消费组成对比
    fetch(
      '/data/Home/XianxiaXingweiFenxiDetail/ButongNianlinGeHangyeXiaofeiZucheng.json'
    )
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.ButongNianlinGeHangyeXiaofeiZuchengData = json.data
      })
    // 请求消费总额度变化趋势
    fetch(
      '/data/Home/XianxiaXingweiFenxiDetail/XiaofeiZongEduBianhuaQushi.json'
    )
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.XiaofeiZongEduBianhuaQushiData = json.data
      })
    // 请求高消费游客来源地占比
    fetch(
      '/data/Home/XianxiaXingweiFenxiDetail/GaoxiaofeiYoukeLaiyuandiZhanbi.json'
    )
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.GaoxiaofeiYoukeLaiyuandiZhanbiData = json.data
      })
    // 请求消费热图
    fetch('/data/Home/XianxiaXingweiFenxiDetail/XiaofeiRetu.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.XiaofeiRetuData = json.data
      })
  },
  methods: {
    chooseCity() {},
    goPage(url) {
      this.$router.push({ path: url })
    }
  }
}
</script>

<style scoped lang="less">
.xianxia-xingwei-detail {
  .tab {
    width: 90%;
    margin: 0 auto 0.4rem;
    height: 0.44rem;
    line-height: 0.42rem;
    text-align: center;
    .current {
      .light-box {
        border: 2px solid rgba(0, 182, 236, 1);
        border-bottom: none;
        background-image: linear-gradient(
          to bottom,
          rgba(0, 182, 236, 0.5),
          rgba(0, 182, 236, 0)
        );
        > div {
          opacity: 1;
        }
      }
    }
    .left {
      position: relative;
      .left::before {
        content: '';
        position: absolute;
        right: -2px;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-image: linear-gradient(
          to left,
          rgba(0, 182, 236, 1),
          rgba(0, 182, 236, 0)
        );
      }
    }
    .right {
      position: relative;
      .right::before {
        content: '';
        position: absolute;
        left: -2px;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-image: linear-gradient(
          to right,
          rgba(0, 182, 236, 1),
          rgba(0, 182, 236, 0)
        );
      }
    }
    > div {
      width: 50%;
      height: 0.44rem;
      float: left;
      > div {
        width: 50%;
        height: 0.44rem;
        float: left;
      }
      .light-box {
        font-size: 0.2rem;
        font-weight: bold;
        border: 2px solid rgba(0, 182, 236, 0);
        border-bottom: 2px solid rgba(0, 182, 236, 1);
        cursor: pointer;
        > div {
          opacity: 0.5;
        }
        .icon {
          float: left;
          width: 25%;
          height: 0.4rem;
          > img {
            width: 0.4rem;
            margin: 0 auto;
            height: 100%;
            display: block;
          }
        }
        .text {
          width: 75%;
          float: left;
          text-align: left;
          padding-left: 0.1rem;
        }
      }
    }
  }
}
.xiaofeizonglan {
  .chart-content {
    .info-list {
      width: 8rem;
      margin: 0 auto;
      overflow: hidden;
      > li {
        width: 2rem;
        float: left;
        > div {
          float: left;
        }
        .icon {
          width: 0.47rem;
          height: 0.47rem;
          margin-right: 0.16rem;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        .text {
          font-weight: bold;
        }
      }
    }
    .spend-map {
      width: 80%;
      margin: 0 auto;
      transform: translateX(-0.2rem);
      height: 5.4rem;
      position: relative;
    }
  }
}
.genianlinrenjunxiaofei {
  .chart-content {
    margin-top: 0.5rem;
  }
}
.xiaofeiedugechengshizhanbi {
  .chart-content {
    height: 210px;
  }
}
.xingbiexiaofeiduibi {
  .chart-content {
    ol {
      width: 50%;
      li {
        width: 50%;
      }
    }
  }
}
.butongnianlingehangyexiaofeizuchengduibi {
  .chart-content {
    ol {
      width: 20%;
      li {
        width: 50%;
      }
    }
  }
}
.xiaofeizongedubianhuaqushi {
  margin-bottom: 1.1rem !important;
  .chart-content {
    height: 240px;
    width: 86%;
    ol {
      width: 30%;
      li {
        width: 33.33%;
      }
    }
  }
}
.gaoxiaofeiyoukelaiyuandizhanbi {
  .chart-content {
    width: 80%;
    .tip {
      margin-bottom: 0.1rem;
      font-size: 0.12rem;
    }
    ol {
      width: 30%;
      li {
        width: 33.33%;
      }
    }
  }
}
.xiaofeiretu {
  .chart-content {
    width: 80%;
  }
}

.geyebili {
  padding: 0 1rem;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 0.05rem !important;
  .chart-content {
    ol {
      width: 44%;
    }
    ul {
      margin: 1rem auto 0;
      position: relative;
      .yibiao1 {
        float: left;
      }
      .yibiao3 {
        float: right;
      }
      .yibiao2 {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -20%) scale(1.5);
      }
      li {
        width: 2.28rem;
        height: 2.28rem;
        position: relative;
        .info {
          margin-top: 0.12rem;
          width: 100%;
          text-align: center;
          .bili {
            color: #ff553e;
          }
        }
        .bg {
          width: 2.28rem;
          height: 1.14rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan.png)
            no-repeat;
          background-size: 100% 100%;
        }
        .pointer {
          transition: all 0.4s;
          width: 2.28rem;
          height: 2.28rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan_pointer.png)
            no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          left: 0;
          transform: rotate(0deg);
        }
      }
    }
  }
}
.child-detail {
  .tingliushijian {
    .chart-content {
      ol {
        width: 28%;
        li {
          width: 33.33%;
        }
      }
    }
  }
  .zhusuretu {
    .chart-content {
      height: 270px;
      width: 80%;
      ol {
        width: 100%;
        li {
          width: 8.33%;
        }
      }
    }
    .expand {
      height: 0.3rem;
      position: absolute;
      left: 1.1rem;
      top: 0.1rem;
      cursor: pointer;
      > div {
        float: left;
        height: 0.3rem;
        line-height: 0.3rem;
      }
      .local {
        width: 0.3rem;
        background: url(../../assets/youkexianxiaxingweifenxi/local.png);
        background-size: 100% 100%;
      }
      .arrow {
        width: 0.3rem;
        background: url(../../assets/header_menu/arrow.png);
        background-size: 100% 100%;
      }
      .city-list {
        position: absolute;
        left: 0;
        top: 0.3rem;
        width: 100%;
        background: #052148;
        border: 1px solid #00cdff;
        padding: 0.05rem 0;
        box-sizing: border-box;
        li:hover {
          background: #0c3964;
        }
      }
    }
  }
}
</style>
